<template>
  <Transition name="fade">
    <div v-if="isEditor.isOpen" class="card mb-4">
      <div class="card-header pb-0">
        <span class="font-weight-bolder" style="font-size: 22px; margin-right: 8px">Account Editor </span>
        <span style="float: right">
          <argon-button v-if="this.$store.state.accountEditor.mode == 'viewAdmin'" @click="closeEditor()" id="changepwd" checked="true" color="secondary" variant="outline" class="mx-2" size="md">Back</argon-button>
          <argon-button v-if="isResetPass" @click="updatePassword()" color="success" size="md">Save Changes</argon-button></span
        >
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="p-0">
          <div class="px-4 m-0 row">
            <div class="card-header pb-0">
              <h6 class="d-inline">Account Details</h6>
              <span v-if="this.$store.state.accountEditor.mode == 'createAdmin'" style="float: right">
                <argon-button @click="closeEditor()" id="changepwd" checked="true" color="secondary" variant="outline" class="mx-2" size="md">Cancel</argon-button>
                <argon-button @click="createAdminAccount()" color="success" size="md">Create Account</argon-button></span
              >
              <argon-switch v-if="this.$store.state.accountEditor.mode == 'viewAdmin'" @click="toggleResetPass()" id="resetPass" class="d-inline-block" name="Reset Password" style="margin-left: 12px"></argon-switch>
              <span v-if="this.$store.state.accountEditor.mode == 'viewAdmin'" style="position: relative; left: -8px" class="text-xs text-secondary">Reset Password Toggle</span>
              <hr />
            </div>
            <div v-if="this.$store.state.accountEditor.mode == 'viewAdmin' && !isResetPass" class="col-md-6">
              <label for="example-text-input" class="form-control-label">Full Name</label>
              <div class="px-1 font-weight-bold text-md">{{ this.$store.state.adminlist.rows[this.$store.state.accountEditor.requestedrow].full_name }}</div>
            </div>
            <div v-if="this.$store.state.accountEditor.mode == 'viewAdmin' && !isResetPass" class="col-md-6 p-2">
              <label for="example-text-input" class="form-control-label">Email address</label>
              <div class="px-1 font-weight-bold text-md">
                <div class="px-1 font-weight-bold text-md">{{ this.$store.state.adminlist.rows[this.$store.state.accountEditor.requestedrow].email }}</div>
              </div>
            </div>

            <div v-if="this.$store.state.accountEditor.mode == 'createAdmin'" class="col-md-6">
              <label for="example-text-input" class="form-control-label">Full Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter admin's full name" />
            </div>
            <div v-if="this.$store.state.accountEditor.mode == 'createAdmin'" class="col-md-6">
              <label for="example-text-input" class="form-control-label">Username</label>
              <argon-input type="text" id="newusername" value="" placeholder="Create a username fot the new account" />
            </div>
            <div v-if="this.$store.state.accountEditor.mode == 'createAdmin'" class="col-md-6">
              <label for="example-text-input" class="form-control-label">Email address</label>
              <argon-input type="email" id="newemail" value="" placeholder="Enter email used for login" />
            </div>
            <div v-if="this.$store.state.accountEditor.mode == 'createAdmin'" class="col-md-6">
              <label for="example-text-input" class="form-control-label">Password</label>
              <argon-input type="password" id="newaccpwd" value="" placeholder="8 Chars long, Uppercase, lowercase, numbers, and special chars" />
            </div>
            <div v-if="this.$store.state.accountEditor.mode == 'createAdmin'" class="col-md-6"></div>
            <div v-if="this.$store.state.accountEditor.mode == 'createAdmin'" class="col-md-6">
              <label for="example-text-input" class="form-control-label">Confirm Password</label>
              <argon-input type="password" id="newaccpwdconfirm" value="" placeholder="Type the password again to make sure both password are same" />
            </div>
            <!-- <div class="col-md-12 pt-3">
            <label for="event-selector" class="form-control-label">Assigned Event</label>
            <Multiselect
              v-model="value"
              mode="single"
              :close-on-select="false"
              :searchable="true"
              :options="[
                { value: 'batman', label: 'Wedding A' },
                { value: 'robin', label: 'Resepsi A' },
                { value: 'joker', label: 'Resepsi B' },
              ]"
            />
          </div> -->
            <div v-if="isResetPass" class="col-md-6">
              <label for="example-text-input" class="form-control-label">New Password</label>
              <input class="form-control" id="newpass" type="password" value="" placeholder="Type this account's new password" />
            </div>
            <div v-if="isResetPass" class="col-md-6">
              <label for="example-text-input" class="form-control-label">New Password Confirmation</label>
              <argon-input type="password" id="newpassconfirm" value="" placeholder="Make sure both new passwords are the same" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
  import ArgonInput from "@/components/ArgonInput.vue";
  import $ from "jquery";
  import ArgonButton from "@/components/ArgonButton.vue";
  import Multiselect from "@vueform/multiselect";
  import ArgonSwitch from "@/components/ArgonSwitch.vue";
  import "@vueform/multiselect/themes/default.css";
  import axios from "axios";

  export default {
    name: "AdminEditor",
    props: {
      cardBg: String,
      selectedOption: {},
    },
    components: {
      ArgonInput,
      ArgonButton,
      ArgonSwitch,
      Multiselect,
    },
    data() {
      return {
        accountdata: {},
        selects: {},
        item: {
          id: 1,
          // both the commented out value and the
          // active value don't work
          // relatedItem: {
          //   value: 100,
          //   label: "test",
          // },
          relatedItem: 100,
        },
      };
    },
    computed: {
      isSuper() {
        return localStorage.getItem(sha256("isSuper").toString());
      },
      isEditor() {
        return this.$store.state.accountEditor;
      },
      getAccountData() {
        return this.accountdata;
      },
      options() {
        return this.options;
      },
      isResetPass() {
        return this.$store.state.accountEditor.resetPass;
      },
    },
    methods: {
      getRoute() {
        const routeArr = this.$route.path.split("/");
        return routeArr[1];
      },
      toggleResetPass() {
        console.log($("#changepwd").is("checked"));
        return (this.$store.state.accountEditor.resetPass = !this.$store.state.accountEditor.resetPass);
      },
      closeEditor() {
        this.$store.state.accountEditor.isOpen = false;
      },
      updatePassword() {
        if ($("#newpass").val() == $("#newpassconfirm").val()) {
          let JWTToken = localStorage.getItem("token");
          let cred = {
            password: $("#newpass").val(),
          };

          axios
            .patch("https://api.macra.co.id/mavent/admin/reset-password", cred, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              alert(res.message);
            })
            .catch((error) => {
              alert(error);
            });
        } else {
          $("#newpass").prop("required", true);
          $("#newpassconfirm").prop("required", true);
          setTimeout(() => {
            $("#newpass").prop("required", false);
            $("#newpassconfirm").prop("required", false);
          }, 3000);
          return alert("Both passwords have to be the same");
        }

        event.preventDefault();
      },
      createAdminAccount() {
        if ($("#newaccpwd").val() == $("#newaccpwdconfirm").val()) {
          let JWTToken = localStorage.getItem("token");
          let cred = {
            full_name: $("#newfullname").val(),
            email: $("#newemail").val(),
            username: $("#newusername").val(),
            password: $("#newaccpwd").val(),
          };

          axios
            .post("https://api.macra.co.id/mavent/admin/add", cred, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              alert(res.status);
            })
            .catch((error) => {
              alert(error);
            });
        } else {
          return alert("Both passwords have to be the same");
        }

        event.preventDefault();
      },

      encrypt(ele) {
        return sha256(ele);
      },
      getAdminData(row) {
        return (this.accountdata = this.$store.state.adminlist.rows[row]);
      },
      async fetchOptions(search) {
        console.log(search);
        // hits an API
        // /api/items/search?search=${search}
        return new Promise((resolve) => {
          setTimeout(() => {
            if (search) {
              resolve([
                {
                  value: 100,
                  label: "test",
                },
                {
                  value: 101,
                  label: "test2",
                },
              ]);
            } else {
              resolve([]);
            }
          }, 200);
        });
      },
    },
    mounted() {
      if (this.$store.state.accountEditor.requestedrow != null) {
        this.getAdminData(this.$store.state.accountEditor.requestedrow);
      }
    },
  };
</script>
